import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mailTitle',
})
export class MailTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value !== 'string' || !value) {
      return value;
    }

    const words = value.trim().split(/\s+/);

    if (words.length <= 8) {
      return value;
    } else {
      return words.slice(0, 6).join(' ') + '...';
    }
  }
}
